import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { map, timeout } from "rxjs/operators";

const mainUrl = environment.url;

@Injectable({
  providedIn: "root",
})
export class GeneralService {
  constructor(private http: HttpClient) {}

  uploadFile(data): Observable<any> {
    return this.http.post(mainUrl + "upload", data).pipe(
      timeout(30000),
      map((res: any) => res.data),
    );
  }

  newUploadFile(data): Observable<any> {
    return this.http.post(mainUrl + "upload-get-list", data).pipe(
      timeout(30000),
      map((res: any) => res.data),
    );
  }

  downloadFilePdf(id): Observable<any> {
    return this.http.get(mainUrl + `files/${id}`);
  }

  downloadFilePdfInactive(id, active): Observable<any> {
    return this.http.get(mainUrl + `dispatch/${id}/ticket?active=${active}`);
  }

  getTRMgraphic(data): Observable<any> {
    return this.http.post(mainUrl + "param-currency/currency-range", data).pipe(
      timeout(30000),
      map((res: any) => res.data),
    );
  }

  createDispatch(data): Promise<any> {
    return this.http.post(mainUrl + "dispatch", data).toPromise();
  }

  createTemporaryDispatch(data): Promise<any> {
    return this.http
      .post(mainUrl + "dispatch/temporal-calculation", data)
      .toPromise();
  }

  createDispatchDraft(data): Promise<any> {
    return this.http.post(mainUrl + "dispatch/save-draft", data).toPromise();
  }

  isInRange(data): Observable<any> {
    return this.http.post(mainUrl + "dispatch/is-in-range", data).pipe(
      timeout(10000),
      map((res: any) => res),
    );
  }

  statusDispatch(status, id): Promise<any> {
    return this.http
      .put(mainUrl + `dispatch/${id}/status-changes?status=${status}`, "")
      .toPromise();
  }

  getDispacthReports(data, page, size): Observable<any> {
    return this.http
      .post(
        mainUrl +
          `report/dispatch?page=${page}&size=${size}&sort=dispatchDate,desc`,
        data,
      )
      .pipe(
        timeout(30000),
        map((res: any) => res.data),
      );
  }

  getDispacthReportsToExcel(data) {
    return this.http
      .post(mainUrl + "report/dispatch-excel", data, {
        reportProgress: true,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res.body;
        }),
      );
  }

  getDispacthConsolidateReports(data, page, size): Observable<any> {
    return this.http
      .post(mainUrl + `report/consolidated?page=${page}&size=${size}`, data)
      .pipe(
        timeout(30000),
        map((res: any) => res.data),
      );
  }

  getDispacthConsolidateReportsToExcel(data) {
    return this.http
      .post(mainUrl + "dispatch/detail-dashboard-excel", data, {
        reportProgress: true,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res.body;
        }),
      );
  }

  getMotherPolicyConsolidateReports(data, page, size): Observable<any> {
    return this.http
      .post(
        mainUrl + `mother-policy/report-consolidated?page=${page}&size=${size}`,
        data,
      )
      .pipe(
        timeout(30000),
        map((res: any) => res.data),
      );
  }

  getMotherPolicyByUser(): Observable<any> {
    return this.http.get(mainUrl + `mother-policy/user`).pipe(
      timeout(60000),
      map((res: any) => res),
    );
  }
  getMotherPolicyByUserResume(): Observable<any> {
    return this.http.get(mainUrl + `mother-policy/user-resume`).pipe(
      timeout(60000),
      map((res: any) => res),
    );
  }
  getMotherPolicyConsolidateReportsToExcel(data) {
    return this.http
      .post(mainUrl + "mother-policy/report-consolidated-excel", data, {
        reportProgress: true,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res.body;
        }),
      );
  }

  getDetailDispacth(data, page, size): Observable<any> {
    return this.http
      .post(
        mainUrl + `dispatch/detail-dashboard?page=${page}&size=${size}`,
        data,
      )
      .pipe(
        timeout(60000),
        map((res: any) => res),
      );
  }

  getOwnerDispatchReport(data, page, size): Observable<any> {
    return this.http
      .post(mainUrl + `dispatch/owner-report?page=${page}&size=${size}`, data)
      .pipe(
        timeout(60000),
        map((res: any) => res),
      );
  }

  getOwnerDispatchReportToExcel(data) {
    return this.http
      .post(mainUrl + "dispatch/owner-report-excel", data, {
        reportProgress: true,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res.body;
        }),
      );
  }

  getOwnerReportInsurers(data): Observable<any> {
    return this.http
      .post(mainUrl + "dispatch/owner-report/filters/insurers", data)
      .pipe(
        timeout(60000),
        map((res: any) => res.data || []),
      );
  }

  getOwnerReportCarrierUsers(data): Observable<any> {
    return this.http
      .post(mainUrl + "dispatch/owner-report/filters/users", data)
      .pipe(
        timeout(60000),
        map((res: any) => res.data || []),
      );
  }

  getOwnerReportBusinessNames(data): Observable<any> {
    return this.http
      .post(mainUrl + "dispatch/owner-report/filters/business-names", data)
      .pipe(
        timeout(60000),
        map((res: any) => res.data || []),
      );
  }

  resendDispatchEmail(dispatchId: number): Observable<any> {
    return this.http
      .post(mainUrl + `dispatch/${dispatchId}/resend-email`, {})
      .pipe(
        timeout(60000),
        map((res: any) => res),
      );
  }

  getPieChartDispacth(data): Observable<any> {
    return this.http.post(mainUrl + `dispatch/pie-chart`, data).pipe(
      timeout(60000),
      map((res: any) => res),
    );
  }

  getBarChartDispacth(): Observable<any> {
    return this.http.get(mainUrl + `dispatch/bar-chart`).pipe(
      timeout(60000),
      map((res: any) => res),
    );
  }

  getAllMotherPolicies(): Observable<any> {
    return this.http.get(mainUrl + `mother-policy`).pipe(
      timeout(30000),
      map((res: any) => res),
    );
  }

  getCityByCountry(countryId, cityName): Observable<any> {
    return this.http
      .get(mainUrl + `countries/${countryId}/cities?city=${cityName}`)
      .pipe(
        timeout(30000),
        map((res: any) => res),
      );
  }

  getIp(): Observable<string> {
    return this.http
      .get(`https://www.cloudflare.com/cdn-cgi/trace`, { responseType: "text" })
      .pipe(
        timeout(3000),
        map((res: any) => res),
      );
  }

  getHeader() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: window.localStorage.getItem("token"),
    });

    return headers;
  }

  getAllDraftsPaged(page, size): Observable<any> {
    return this.http.get(mainUrl + `dispatch/drafts/${page}/${size}`).pipe(
      timeout(30000),
      map((res: any) => res.data),
    );
  }
}
